import {
  call, put, take,
} from 'redux-saga/effects';
import {
  refreshFail,
  refreshRequest,
  refreshSuccess,
} from './modules/auth/actions';
import history from '../history';
import { pageNotFound } from '../routes/dashboard/errors';
import { checkUrlsForRedirect } from './util';

/* eslint-disable @typescript-eslint/no-explicit-any, no-restricted-syntax */

export function* apiCall<FN extends(...args: any[]) => any>(
  method: FN,
  ...args: Parameters<FN>) {
  try {
    return yield call(method, ...args);
  } catch (e) {
    if (e.response?.status === 401) {
      yield put(refreshRequest());
      const result = yield take([refreshSuccess.type, refreshFail.type]);

      if (result.type === refreshSuccess.type) {
        return yield call(method, ...args);
      }
    }

    if (e.response?.status === 404) {
      const { url } = e.config;

      if (checkUrlsForRedirect(url)) {
        history.push(pageNotFound.path as string);
        return null;
      }
    }

    throw e;
  }
}

type ReturnGen = {
  data: any;
  error?: string | Error;
  [key: string]: any;
};
export function* forEachGen(array: Array<any>, fn: (data: any) => any, needNumbers?: boolean) {
  const responses = [];
  for (const [i, v] of array.entries()) {
    try {
      const response = needNumbers? yield* fn({val:v, index: i}): yield* fn(v);
      responses.push(response);
    } catch (error) {
      responses.push({
        data: v,
        error: error.response?.data?.error || error,
      });
      console.error(error);
    }
  }

  return responses;
};
